import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-connect',
  templateUrl: './connect.component.html',
  styleUrls: ['./connect.component.scss']
})
export class ConnectComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
